import CheckRounded from '@mui/icons-material/CheckRounded';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import './Notice.module.scss';

const ICONS = {
  info: InfoOutlined,
  success: CheckRounded,
  warning: WarningAmberRounded,
  danger: ErrorOutlineRounded,
};

// The design system's Notice: a short safety message. The title says what is
// happening; the text says what to do about it.
const Notice = ({ tone = 'info', title, icon, action, children }) => {
  const Icon = ICONS[tone];
  return (
    <div
      className={`ts-notice ts-notice--${tone}`}
      role={tone === 'danger' ? 'alert' : 'status'}
    >
      {icon ?? <Icon className="ts-notice__icon" aria-hidden="true" />}
      <div className="ts-notice__body">
        {title && <p className="ts-notice__title">{title}</p>}
        {children && <div className="ts-notice__text">{children}</div>}
        {action && <div className="ts-notice__action">{action}</div>}
      </div>
    </div>
  );
};

export default Notice;
